import React from "react";
import { Check } from "lucide-react";

const OPTS = [["diabetes", "Diabetes"], ["heart", "Heart or circulatory condition"], ["lung", "COPD or chronic lung condition"]];

export const CaseConditions = ({ conditions, status, busy, onChange, agent }) => {
  const sel = conditions || [];
  const toggle = (k) => {
    const next = sel.includes(k) ? sel.filter((x) => x !== k) : [...sel, k];
    onChange({ conditions: next, status: "answered" });
  };
  return (
    <section className="rounded-xl border border-[#E1E6EC] bg-white p-4" data-testid="case-conditions">
      <p className="text-sm font-semibold text-[#0B192C]">{agent ? "Has the client been diagnosed with any of these?" : "Have you been diagnosed with any of these?"} <span className="font-normal text-[#5A6B7B]">(Optional)</span></p>
      <div className="mt-2 flex flex-wrap gap-2">
        {OPTS.map(([k, label]) => {
          const on = sel.includes(k);
          return (
            <button key={k} type="button" disabled={busy} onClick={() => toggle(k)} aria-pressed={on}
              className={`inline-flex min-h-11 items-center gap-1.5 rounded-full border px-3 py-2 text-sm ${on ? "border-[#1E3E62] bg-[#1E3E62] text-white" : "border-[#BCCCDC] bg-white text-[#1E3E62]"}`}
              data-testid={`case-condition-${k}`}>{on && <Check className="h-4 w-4" />}{label}</button>
          );
        })}
        <button type="button" disabled={busy} onClick={() => onChange({ conditions: [], status: "none" })} aria-pressed={status === "none"}
          className={`min-h-11 rounded-full border px-3 py-2 text-sm ${status === "none" ? "border-[#1E3E62] bg-[#EEF2F6] text-[#0B192C]" : "border-[#BCCCDC] bg-white text-[#5A6B7B]"}`}
          data-testid="case-condition-none">None of these</button>
      </div>
      <p className="mt-2 text-xs text-[#5A6B7B]">Self-reported. Special plans for these conditions may be included; each plan confirms eligibility. You can skip this.</p>
    </section>
  );
};
